import ThemeSlider from './ThemeSlider';
import { generateRulerSettings } from './utils';

export { generateRulerSettings };
export default ThemeSlider;
